import AutoCloseConfiguration from './AutoCloseConfiguration';

export { AutoCloseConfiguration };
export default AutoCloseConfiguration;
